<template>
  <AuthenticatedLayout :activeMenuItem='props.collection' :title='title'>
    <PaddedLayout>
      <BreadcrumbView :pages='pages' />

      <div class='flex flex-wrap py-2 justify-between items-center gap-2 w-full mt-2'>
        <h1 class='text-2xl'>{{ title }}</h1>
      </div>

      <CollectionCreateForm :collection='props.collection' />
    </PaddedLayout>
  </AuthenticatedLayout>
</template>

<script setup>

import AuthenticatedLayout from '@/components/layouts/authenticated-layout.vue';
import PaddedLayout from '@/components/layouts/padded-layout.vue';

import BreadcrumbView from '@/components/views/breadcrumb-view.vue';
import LinkButton from '@/components/buttons/link-button.vue';
import CollectionCreateForm from '@/components/forms/collection-create-form.vue';

import { getCollection } from '@/kernel/collections';

const props = defineProps({
  collection: String
});

const collection = getCollection(props.collection);

const pages = [
  {name: collection.getPluralLabel(), href: collection.getIndexUrl(), current: false },
  {name: `Create ${collection.getSingleLabel()}`, href: collection.getCreateUrl(), current: true }
];

const title = `Create ${collection.getSingleLabel()}`;

</script>
